import React from "react";
import { BoxAssignments } from "./box_assignments.jsx";
import { StableHorses } from "./stable_horses.jsx";

// Horses | Boxes (spec S4). Horses is the default; go("boxes") still opens the
// grid. Until a realm holds the horse reads, Horses answers 404: the tab then
// opens on Boxes and says so, rather than showing an empty stable.
export function StableTab({ sale, vendor = window.VD.access.realm, go, initialView = "horses" }) {
  const [view, setView] = React.useState(initialView);
  const [denied, setDenied] = React.useState(false);
  const tab = (id, label) => <button type="button" role="tab" aria-selected={view === id}
    className={view === id ? "on" : ""} onClick={() => setView(id)}>{label}</button>;
  return <div className="stable-tab">
    <div className="seg" role="tablist" aria-label="Stable">{tab("horses", "Horses")}{tab("boxes", "Boxes")}</div>
    {view === "boxes" && <BoxAssignments sale={sale} vendor={vendor}/>}
    {view === "horses" && denied && <p role="status">Horse details aren't part of your access yet.</p>}
    {view === "horses" && !denied && <StableHorses sale={sale} vendor={vendor} go={go}
      onDenied={() => { setDenied(true); setView("boxes"); }}/>}
  </div>;
}
